<mat-chip-set class="appliedFilters" [class.visible]="appliedFilters()?.length">
	@for (searchColumn of appliedFilters(); track searchColumn.value) {
		<mat-chip [@zoomInOnEnter] [@zoomOutOnLeave] (removed)="formService.clearFilter(searchColumn)">
			{{ searchColumn.displayName | translate }}
			<button matChipRemove>
				<mat-icon fontSet="fas" fontIcon="fa-times-circle" />
			</button>
		</mat-chip>
	}
</mat-chip-set>
